import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "cremationServices",
    "burialServices",
    "burialToggle",
    "styledLists",
    "subheader",
    "unstyledLists",
    "tableHeader",
  ];
  static values = {
    burialsPresent: Boolean,
  };

  connect() {
    this.equalizeAll();
    window.addEventListener("resize", () => this.equalizeAll());
    this.observeCollapseResize();
  }

  updatePricing(_event) {
    const burialTable = document.getElementById("burial-services-table");
    if (burialTable.hasAttribute("data-burials-present")) {
      this.burialToggleTarget.classList.remove("hidden");
    } else {
      this.burialToggleTarget.classList.add("hidden");
    }

    this.cremationServicesTarget.classList.toggle("hidden");
    this.burialServicesTarget.classList.toggle("hidden");
    this.equalizeAll();
  }

  observeCollapseResize() {
    let observer = new ResizeObserver(() => this.equalizeAll());
    [...this.element.querySelectorAll(".hs-collapse")].forEach((collapse) =>
      observer.observe(collapse)
    );
  }

  equalizeAll() {
    this.equalizeHeights(this.tableHeaderTargets);
    this.equalizeHeights(this.subheaderTargets);
    this.equalizeHeights(this.styledListsTargets);
    this.equalizeHeights(this.unstyledListsTargets);
  }

  equalizeHeights(sections) {
    if (window.innerWidth > 767) {
      let maxHeight = 0;

      sections.forEach((section) => {
        section.style.minHeight = "";
      });

      sections.forEach((section) => {
        maxHeight = Math.max(maxHeight, section.offsetHeight);
      });

      sections.forEach((section) => {
        section.style.minHeight = maxHeight + "px";
      });
    } else {
      sections.forEach((section) => {
        section.style.height = "auto";
      });
    }
  }
}
